const API_BASE = '/api/funding-hq';
const PREVIEW_PATH = `${API_BASE}/clients/import/preview`;
const COMMIT_PATH = `${API_BASE}/clients/import/commit`;

function getAuthToken() {
  return (
    localStorage.getItem('fundelite_token')
    || localStorage.getItem('token')
    || localStorage.getItem('access_token')
    || localStorage.getItem('authToken')
  );
}

function backendBaseUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  return raw.replace(/\/api$/, '');
}

export const IMPORT_FIELD_OPTIONS = [
  { key: '', label: '— Skip —' },
  { key: 'first_name', label: 'First Name' },
  { key: 'last_name', label: 'Last Name' },
  { key: 'owner_name', label: 'Owner / Full Name' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'dob', label: 'Date of Birth' },
  { key: 'ssn', label: 'SSN' },
  { key: 'ein', label: 'EIN' },
  { key: 'personal_address', label: 'Personal Address' },
  { key: 'personal_city', label: 'City' },
  { key: 'personal_state', label: 'State' },
  { key: 'personal_zip', label: 'ZIP' },
  { key: 'employer', label: 'Employer' },
  { key: 'occupation', label: 'Occupation' },
  { key: 'personal_income', label: 'Personal Income' },
  { key: 'business_name', label: 'Business Name' },
  { key: 'business_address', label: 'Business Address' },
  { key: 'business_start_date', label: 'Business Start Date' },
  { key: 'desired_amount', label: 'Desired Funding Amount' },
  { key: 'notes', label: 'Notes' },
  { key: 'source', label: 'Source' },
];

export async function previewClientImport(file, { agencyId } = {}) {
  const token = getAuthToken();
  const formData = new FormData();
  formData.append('file', file, file.name);
  const query = agencyId ? `?agency_id=${encodeURIComponent(agencyId)}` : '';
  const response = await fetch(`${backendBaseUrl()}${PREVIEW_PATH}${query}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.detail || data?.message || 'Could not parse import file.');
  }
  return data;
}

export async function validateClientImport({ agencyId, mapping, rows }) {
  const token = getAuthToken();
  const response = await fetch(`${backendBaseUrl()}${API_BASE}/clients/import/validate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      agency_id: agencyId,
      mapping,
      rows,
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.detail || data?.message || 'Import validation failed.');
  }
  return data.validation;
}

export async function commitClientImport({ agencyId, mapping, rows }) {
  const token = getAuthToken();
  const response = await fetch(`${backendBaseUrl()}${COMMIT_PATH}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      agency_id: agencyId,
      mapping,
      rows,
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.detail || data?.message || 'Import commit failed.');
  }
  return data;
}

export function buildMappingRows(headers = [], detectedMapping = {}) {
  return IMPORT_FIELD_OPTIONS
    .filter((option) => option.key)
    .map((option) => ({
      label: option.label,
      fieldKey: option.key,
      column: detectedMapping[option.key] || '',
      options: ['', ...headers],
    }));
}

export function mappingObjectFromRows(mappingRows = []) {
  return mappingRows.reduce((acc, row) => {
    if (row.column) {
      acc[row.fieldKey] = row.column;
    }
    return acc;
  }, {});
}

export function validationStats(validation) {
  const rows = validation?.rows || [];
  return {
    total: rows.length,
    ready: rows.filter((row) => row.status === 'valid').length,
    warnings: rows.filter((row) => row.status === 'warning').length,
    duplicates: rows.filter((row) => (
      row.status === 'error'
      && (row.errors || []).some((error) => error.toLowerCase().includes('existing client'))
    )).length,
    errors: rows.filter((row) => row.status === 'error').length,
  };
}
